import authFetch from './fetch';
import qs from 'qs';
import { makeRequest, getQueryParams } from './utils';

export const getInvoicesDashboard = async () => {
  try {
    const response = await authFetch.get('/api/Invoices/Dashboard');
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const getInvoicesRules = async () => {
  try {
    const response = await authFetch.get('/api/Invoices/Rules');
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const getInvoiceTypes = async () => {
  try {
    const response = await authFetch.get('/api/CreditTerms/OrderInvoiceTypes');
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const postInvoicesRules = async (values) => {
  try {
    const response = await authFetch.post('/api/Invoices/Rules', values);
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const getStopTypes = (params) => makeRequest(authFetch.get(`/api/StopTypes${getQueryParams(params)}`));

export const getStopTypesValues = async () => {
  try {
    const response = await authFetch.get('/api/StopTypes/Values');
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const putStopType = async (values) => makeRequest(authFetch.put('/api/StopTypes', values));

export const getInvoicesGrid = async (search) => {
  try {
    const response = await authFetch.get(
      `/api/Invoices/Grid?${search && Object.keys(search).length ? qs.stringify(search) : ''}`,
    );
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const getInvoicesById = async (invoiceNumber) => {
  try {
    const response = await authFetch.get(`/api/Invoices/DetailsById?invoiceNumber=${invoiceNumber}`);
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const getCsvData = async (data) => {
  try {
    const response = await authFetch.post('/api/Invoices/CreateCsv', data);
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const createInvoiceForOrder = async (proNumber) => {
  try {
    const response = await authFetch.get(`/api/Invoices/CreateInvoiceForOrder/${proNumber}`);
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const generateInvoiceEstimateReport = async (proNumber) => {
  try {
    const response = await authFetch.get(`/api/Invoices/GenerateInvoiceEstimateReport/${proNumber}`);
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const getInvoiceDocument = async (proNumber, billToId, invoiceId) => {
  try {
    const response = await authFetch.get(
      `/api/Invoices/Document${getQueryParams({ proNumber, billToId, invoiceId })}`,
    );
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const exportToSage = async (params) => {
  try {
    const response = await authFetch.get(
      `/api/Invoices/ExportToSage${getQueryParams(params)}`,
    );
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const getInvoiceLineItemsAudits = (id, params) => makeRequest(authFetch.get(`/api/Invoices/LineItem/${id}/Audits${getQueryParams(params)}`));

export const getInvoiceLineItemsAuditsUsers = (id) => makeRequest(authFetch.get(`/api/Invoices/LineItem/${id}/Audits/Users`));
export const getInvoiceLineItemsAuditsProperties = (id) => makeRequest(authFetch.get(`/api/Invoices/LineItem/${id}/Audits/Properties`));

export const getInvoiceLineItemTypesAudits = (id, params) => makeRequest(authFetch.get(`/api/InvoiceLineItemTypes/${id}/Audits${getQueryParams(params)}`));
export const getInvoiceLineItemTypesAuditsUsers = (id) => makeRequest(authFetch.get(`/api/InvoiceLineItemTypes/${id}/Audits/Users`));
export const getInvoiceLineItemTypesAuditsProperties = (id) => makeRequest(authFetch.get(`/api/InvoiceLineItemTypes/${id}/Audits/Properties`));

export const recalculateFuel = (proNumber) => makeRequest(authFetch.patch(`/api/Orders/${proNumber}/Invoicing/Recalculate`));
export const setAccesorialStatusesToComplete = (params) => makeRequest(authFetch.patch('api/CMSv2/Invoices/ConfirmCharges', params));

export const bulkUpsertInvoices = (params) => makeRequest(authFetch.put('api/Invoices/BulkUpsert', params));
